import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        openModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllProcessLawyer = async () => {

        const { fetchAllProcessLawyer } = FetchData
        const { executeFetch } = fetchAllProcessLawyer

        executeFetch()

    }

    const handleClickFetchSpecificProcessLawyer = async (idlawyer) => {
        
        const { FormScreen: {onResetForm} } = Forms

        const { fetchSpecificProcessLawyer } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificProcessLawyer

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idlawyer: idlawyer})
        executeFetch()

        handleClickShowForm(true)

    }

    const handleClickDeleteProcessLawyer = async (idlawyer) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal-notarial/delete-process-lawyer/${idlawyer}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllProcessLawyer()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickCloseForm = () => {
        const { setStepApplilication } = globalStates
        const { FormScreen, FormOtherExpense } = Forms
        FormScreen.onResetForm()
        FormOtherExpense.onResetForm()
        setStepApplilication(0)

        handleClickShowForm(false)
    }

    const handleClickFetchAllExpenses = async () => {

        const { fetchAllExpenses } = FetchData
        const { executeFetch } = fetchAllExpenses

        executeFetch()

    }

    const handleClickFetchSpecificExpense = async (idlawyerexpense) => {
        
        const { fetchSpecificExpense } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificExpense

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        handleClickResetOtherExpenseForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idlawyerexpense: idlawyerexpense})
        executeFetch()


    }

    const handleClickDeleteExpense = async (idlawyerexpense) => {

        const { fetchAllExpenses } = FetchData
        const { FormOtherExpense } = Forms
        const { formState } = FormOtherExpense

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal-notarial/delete-expense/${idlawyerexpense}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllExpenses()
                    fetchAllExpenses.setParamsToSearch({idlawyer: formState.idlawyer})
                    fetchAllExpenses.executeFetch()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }
    
    const handleClickResetOtherExpenseForm = async () => {

        const { FormOtherExpense } = Forms
        const { setFormState } = FormOtherExpense

        setFormState(prevState => ({
            ...prevState,
            idexpense: '',
            amount: '',
            observation: ''
        }))
        
    }

    const handleClickAddPayment = async (idlawyer) => {
        navigate(`/juridico/procesos/pagos/${idlawyer}`)
    }

    const handleClickOpenDiscountModal = async ( _, title, compont, dataRequest, flagModalOpeningMode ) => {

        const { setModalOpeningMode } = globalStates
        const { DiscountForm } = Forms
        const { setFormState } = DiscountForm
        
        const idlawyer = parseFloat(dataRequest.data.idlawyer)
        const saldo_total = parseFloat(dataRequest.data.saldo_total)
        setFormState((prevState) => ({
            ...prevState,
            idlawyer: idlawyer,
            discount: saldo_total
        }))

        setModalOpeningMode((saldo_total === 0 ) ? 'READONLY' : 'EDITABLE')
        openModal(_, title, compont, dataRequest)

    }
    
    const handleClickContinue = async () => {
        const { fetchAllExpenses, fetchAllLogs } = FetchData
        const { FormScreen, FormOtherExpense, LawyerLogsForm } = Forms

        FormOtherExpense.formState.idlawyer = FormScreen.formState.idlawyer
        fetchAllExpenses.setParamsToSearch({idlawyer: FormScreen.formState.idlawyer})
        fetchAllExpenses.executeFetch()

        LawyerLogsForm.formState.idlawyer = FormScreen.formState.idlawyer
        fetchAllLogs.setParamsToSearch({idlawyer: FormScreen.formState.idlawyer})
        fetchAllLogs.executeFetch()

        handleClickNextStep()
    }

    const handleClickFetchAllLogs = async () => {

        const { fetchAllLogs } = FetchData
        const { executeFetch } = fetchAllLogs

        executeFetch()

    }

    const handleClickDeleteLog = async (idlawyerlogs) => {

        const { fetchAllLogs } = FetchData
        const { LawyerLogsForm } = Forms
        const { formState } = LawyerLogsForm

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal-notarial/delete-log/${idlawyerlogs}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    fetchAllLogs.setParamsToSearch({idlawyer: formState.idlawyer})
                    fetchAllLogs.executeFetch()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickResetLawyerLogForm = async () => {

        const { LawyerLogsForm } = Forms
        const { setFormState } = LawyerLogsForm

        setFormState(prevState => ({
            ...prevState,
            // date_log: '',
            observations: ''
        }))
        
    }

    const handleClickToggleSatus = async (idlawyer) => {

        const { fetchAllProcessLawyer } = FetchData

        const body = {
            idlawyer: idlawyer,
            estado: 0, // 0 para marcarlo como finalizado
            user: user.username,
        }

        Swal.fire({
            title: '¿Está seguro de marcar este registro como finalizado?',
            text: 'Esta acción no se puede deshacer, haga click en "Confirmar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Confirmar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.post(`/legal-notarial/toggle-lawyer-process-status`, body)
                    .then(({ data }) => {
                        fetchAllProcessLawyer.executeFetch()
                        alertMessage(data)

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
        
    }

    const handleClickCreateEvent = async (idlawyerlogs) => {

        const { fetchAllLogs } = FetchData
        const { LawyerLogsForm } = Forms
        const { formState } = LawyerLogsForm

        const body = {
            idlawyerlogs: idlawyerlogs,
            user: user.username,
        }

        Swal.fire({
            title: '¿Está seguro de crear un evento de agenda para esta entrada de bitácora?',
            text: 'Haga click en "Confirmar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Confirmar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.post(`/legal-notarial/create-event`, body)
                    .then(({ data }) => {
                        
                        fetchAllLogs.setParamsToSearch({idlawyer: formState.idlawyer})
                        fetchAllLogs.executeFetch()
                        alertMessage(data)

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
        
    }

    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { fetchAllExpenses, fetchAllLogs } = FetchData
        const { FormScreen, FormOtherExpense, LawyerLogsForm } = Forms
        const { formState } = FormScreen

        const _dataBody = {
            idlawyer: formState.idlawyer,
            idprocesstype: formState.idprocesstype,
            idcliente: formState.idcliente,
            date_start: formState.date_start,
            initial_amount: formState.initial_amount,
            process_number: formState.process_number,
            observations: formState.observations,
            flag_paid: formState.flag_paid,
            user: user.username,
            process_ministry: formState.process_ministry
        }

        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        if(_dataBody.idlawyer > 0){

            await marvarApi.put( `/legal-notarial/update-process-lawyer/${_dataBody.idlawyer}`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    handleClickFetchAllProcessLawyer()
                    
                    FormOtherExpense.formState.idlawyer = formState.idlawyer
                    fetchAllExpenses.setParamsToSearch({idlawyer: formState.idlawyer})
                    fetchAllExpenses.executeFetch()

                    LawyerLogsForm.formState.idlawyer = formState.idlawyer
                    fetchAllLogs.setParamsToSearch({idlawyer: formState.idlawyer})
                    fetchAllLogs.executeFetch()

                    handleClickNextStep()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/legal-notarial/create-process-lawyer`, _dataBody )
                .then(({ data }) => {

                    console.log('post: /legal-notarial/create-process-lawyer ', data)
                    
                    alertMessage(data)

                    if (data.flag === 'OK') {
                        const idlawyer = data.rows[0].insertId
                        console.log('idlawyer', idlawyer)
                        formState.idlawyer = idlawyer
                        FormOtherExpense.formState.idlawyer = idlawyer
                        fetchAllExpenses.setParamsToSearch({idlawyer: formState.idlawyer})
                        fetchAllExpenses.executeFetch()
                        handleClickFetchAllProcessLawyer()

                        handleClickNextStep()
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const onSubmitOtherExpensesForm = async (e) => {

        e.preventDefault()

        const { fetchAllExpenses } = FetchData
        const { FormOtherExpense } = Forms
        const { formState } = FormOtherExpense

        const _dataBody = {
            idlawyerexpense: formState.idlawyerexpense,
            idlawyer: formState.idlawyer,
            idexpense: formState.idexpense,
            amount: formState.amount,
            observation: formState.observation,
            user: user.username
        }

        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        if(_dataBody.idlawyerexpense > 0){

            await marvarApi.put( `/legal-notarial/update-expense/${_dataBody.idlawyerexpense}`, _dataBody )
                .then(({ data }) => {
                    alertMessage(data)
                    handleClickFetchAllProcessLawyer()
                    fetchAllExpenses.setParamsToSearch({idlawyer: formState.idlawyer})
                    fetchAllExpenses.executeFetch()
                    handleClickResetOtherExpenseForm()
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/legal-notarial/create-expense`, _dataBody )
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.flag === 'OK') {
                        handleClickFetchAllProcessLawyer()
                        fetchAllExpenses.setParamsToSearch({idlawyer: formState.idlawyer})
                        fetchAllExpenses.executeFetch()
                        handleClickResetOtherExpenseForm()
                    }
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const onSubmitDiscountModal = async (e) => {

        e.preventDefault()

        const { fetchAllExpenses } = FetchData
        const { DiscountForm } = Forms
        const { formState, onResetForm } = DiscountForm

        const _dataBody = {
            idlawyer: formState.idlawyer,
            discount: formState.discount,
            user: user.username
        }

        console.log('[useActions][onSubmitDiscountModal] _dataBody ', _dataBody)

        await marvarApi.post(`/legal-notarial/save-discount-process-lawyer`, _dataBody )
            .then(({ data }) => {
                alertMessage(data)
                handleClickFetchAllProcessLawyer()
                fetchAllExpenses.setParamsToSearch({idlawyer: formState.idlawyer})
                fetchAllExpenses.executeFetch()
                onResetForm()
                closeModal()
            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }

    const onSubmitLawyerLog = async (e) => {

        e.preventDefault()

        const { fetchAllLogs } = FetchData
        const { LawyerLogsForm } = Forms
        const { formState } = LawyerLogsForm

        const _dataBody = {
            idlawyer: formState.idlawyer,
            date_log: formState.date_log,
            observations: formState.observations,
            user: user.username
        }

        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        await marvarApi.post( `/legal-notarial/create-log`, _dataBody )
            .then(({ data }) => {
                alertMessage(data)
                if (data.flag === 'OK') {
                    fetchAllLogs.setParamsToSearch({idlawyer: formState.idlawyer})
                    fetchAllLogs.executeFetch()
                    handleClickResetLawyerLogForm()
                }
            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }

    return Object.freeze({
        openModal,
        closeModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllProcessLawyer,
        handleClickFetchSpecificProcessLawyer,
        handleClickDeleteProcessLawyer,
        handleClickReturnStep,
        handleClickNextStep,
        handleClickCloseForm,
        handleClickFetchAllExpenses,
        handleClickFetchSpecificExpense,
        handleClickDeleteExpense,
        handleClickResetOtherExpenseForm,
        handleClickAddPayment,
        handleClickOpenDiscountModal,
        handleClickContinue,
        handleClickFetchAllLogs,
        handleClickDeleteLog,
        handleClickResetLawyerLogForm,
        handleClickToggleSatus,
        handleClickCreateEvent,
        onSubmitForm,
        onSubmitOtherExpensesForm,
        onSubmitDiscountModal,
        onSubmitLawyerLog,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}